export const SCA_DEFAULT = "default";
export const SCA_FAILED = "failed";
export const SCA_SUCCESS = "success";
export type confirmStatusType = typeof SCA_SUCCESS | typeof SCA_FAILED | typeof SCA_DEFAULT;
